(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-oz-brands-toggle]');
    if (!button) return;
    const container = button.closest('[data-oz-brands]');
    if (!container) return;
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    container.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-offer-bar"]) return;
  try {
    
  if (!customElements.get('oz-offer-bar')) {
    customElements.define('oz-offer-bar', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.oz-offer-bar__slide')];
        this.toggle = this.querySelector('.oz-offer-bar__toggle');
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.show(0);
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.resumeLabel : this.toggle.dataset.pauseLabel);
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events.abort();
      }

      show(index) {
        this.index = index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || document.hidden) return;
        this.timer = setTimeout(() => {
          this.show((this.index + 1) % this.slides.length);
          this.schedule();
        }, Number(this.dataset.interval) || 5000);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
